module.exports = __webpack_public_path__ + "static/media/vertex-9002x.fd4ebd7a.jpg";